import {
  GET_SECTOR_ITEMS_AND_PRODUCTS,
  GET_SECTOR_ITEMS_AND_PRODUCTS_ERROR,
  GET_SECTOR_ITEMS_AND_PRODUCTS_SUCCESS
} from './SectorItemsAndProductsSection.actions'

const sectorItemsAndProductsSectionState = {
  category: null,
  csv: [],
  data: [],
  error: null,
  family: null,
  loading: false,
  type: 'segments'
}

/**
 * The sector items and products section's reducer.
 */
const sectorItemsAndProductsSectionReducer = (state = sectorItemsAndProductsSectionState, { payload, type }) => {
  switch (type) {
    case GET_SECTOR_ITEMS_AND_PRODUCTS: {
      // TODO: Find out why the treemap does not render correctly when changing between levels.
      // Weirdly when resetting the data the chart actually does renders right.
      return { ...state, data: [], loading: true }
    }
    case GET_SECTOR_ITEMS_AND_PRODUCTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_ITEMS_AND_PRODUCTS_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default sectorItemsAndProductsSectionReducer
